import React, {Component} from 'react';
import PropTypes from 'prop-types';

class HoverLines extends Component {

  shouldComponentUpdate(nextProps) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const xDiff = nextProps.hoverX !== this.props.hoverX;
    const yDiff = nextProps.hoverY !== this.props.hoverY;

    return widthDifferent || heightDifferent || xDiff || yDiff;
  }

  render() {
    const isX = this.props.type === 'x';
    const x = this.props.hoverX;
    const y = this.props.hoverY;

    const x1 = isX ? 0 : x;
    const x2 = isX ? x : this.props.width;

    return (
      <g>
        {x > -1 && y > -1 &&
        <g>
          <line
            x1={x1}
            x2={x2}
            y1={y}
            y2={y}
            className="hoverLine">
          </line>
          <line
            x1={x}
            x2={x}
            y1={y}
            y2={this.props.height}
            className="hoverLine">
          </line>
        </g>
        }
      </g>
    );
  }
}

HoverLines.propTypes = {
  type: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  hoverX: PropTypes.number,
  hoverY: PropTypes.number
};

export default HoverLines;




// WEBPACK FOOTER //
// ./src/charts/AreaChart/HoverLines.js